import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import SvgVue from "svg-vue3";
import "@/scss/app.scss";
import * as Sentry from "@sentry/vue";
import dayjs from "dayjs";
import "dayjs/locale/nl";

createInertiaApp({
    progress: {
        color: "#29d",
    },
    resolve: (name) => import(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        const VueApp = createApp({ render: () => h(App, props) });

        dayjs.locale("nl");
        VueApp.config.globalProperties.$dayjs = dayjs;

        if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging") {
            Sentry.init({
                VueApp,
                dsn: "https://5262cd9a4a4f402fb1c7f72aa69d83ab@o315551.ingest.sentry.io/6311001",
                environment: `${process.env.NODE_ENV}-frontend`,
            });
        }

        VueApp.use(SvgVue).use(plugin).mixin({ methods: { route } }).mount(el);
    },
});
